import { render, staticRenderFns } from "./PrinterForm.vue?vue&type=template&id=f445a94a"
import script from "./PrinterForm.vue?vue&type=script&lang=ts"
export * from "./PrinterForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports